module.exports = __webpack_public_path__ + "static/media/storieFour.34300a5d.png";